/**
 * CookieBot: availability, consent getter, waitFor CookieBot.
 * @package AdvancedTrackingManager
 */

import { waitFor } from '@lib/dom';
import { createLogger } from '@lib/logger';

const w = globalThis as unknown as Window;

export const isCookieBotAvailable = (): boolean =>
  typeof w.Cookiebot !== 'undefined' ||
  typeof (w as { CookieConsent?: unknown }).CookieConsent !== 'undefined' ||
  typeof (w as { cookiebot?: unknown }).cookiebot !== 'undefined';

export const getCookieBotConsent = (category: string): boolean => {
  if (typeof w.Cookiebot !== 'undefined' && w.Cookiebot.consent) {
    return w.Cookiebot.consent[category] ?? false;
  }
  const cc = (w as { CookieConsent?: { consent?: Record<string, boolean> } }).CookieConsent;
  if (cc?.consent) {
    return cc.consent[category] ?? false;
  }
  const cb = (w as { cookiebot?: { consent?: Record<string, boolean> } }).cookiebot;
  if (cb?.consent) {
    return cb.consent[category] ?? false;
  }
  return false;
};

/**
 * Wait for CookieBot to load (e.g. via GTM), then run callback.
 */
export const waitForCookieBot = (
  callback: () => void,
  maxAttempts = 50
): void => {
  const timeout = maxAttempts * 100;
  waitFor(isCookieBotAvailable, { interval: 100, timeout })
    .then(callback)
    .catch(() => {
      createLogger('ATM Consent Handler', false).debug('CookieBot not detected after waiting');
    });
};
